import axios, { AxiosInstance, AxiosResponse, CancelTokenSource } from 'axios';
import { IOdataResult } from '../models/odata.model';
import { fetchAppConfig } from './configUtil';

const fetchOdataAll = async <T>(axiosInstance: AxiosInstance, url: string, params: any, cancelToken?: CancelTokenSource, cancelTokenName?: string, combinedResult: T[] = []): Promise<AxiosResponse<IOdataResult<T>>> => {
  // Cancelation token
  cancelToken?.cancel(cancelTokenName);
  cancelToken = axios.CancelToken.source();

  const result = await axiosInstance.get<IOdataResult<T>>(url, {
    params: {
      ...params,
    },
  });

  const newResult = {
    ...result,
    data: {
      ...result.data,
      items: [...combinedResult, ...result.data.items],
    },
  } as AxiosResponse<IOdataResult<T>>;

  if (result.data.nextPageLink) {
    const nestedResult = await fetchOdataAll(axiosInstance, await getRatConvertedNextPageLink(result.data.nextPageLink), {}, cancelToken, cancelTokenName, newResult.data.items);
    return nestedResult;
  }

  return newResult;
};

const getRatConvertedNextPageLink = async (nextPageLink: string) => {
  /*
   * When an odata query returns a next page link, the URL will be the RESOURCE endpoint, not the RAT endpoint.
   * This URL therefore needs to be converted so the first part of the URL is replaced with the RAT URL.
   *
   * The resource URL is structured as:
   * {protocol}://{host}:{port}/{baseRoute}/{apiPath}
   * e.g., https://apps-customername.autoapps.cloud:8061/resource/api/contact/list
   *       https://apps-customername.autoapps.cloud:8061/resourcePilot/api/contact/list
   *       https://webtest.avhodom2.com:30001/Resource/api/contact/list
   *
   * This will be translated to:
   * {ratUrl}/{apiPath}
   * e.g., https://rat.autoapps.cloud/api/contact/list
   *       https://webtest.avhodom2.com:30004/api/contact/list
   *
   * The function dynamically strips the base route (first path segment) and appends the remaining API path to the RAT URL.
   */

  const appConfig = await fetchAppConfig();

  try {
    debugger;
    // Parse the nextPageLink URL
    const url = new URL(nextPageLink);

    // Extract the pathname (e.g., "/resource/api/contact/list")
    const pathname = url.pathname;

    // Split the pathname and remove the first segment (base route)
    // pathname.split('/') gives: ['', 'resource', 'api', 'contact', 'list']
    const pathSegments = pathname.split('/').filter((segment) => segment.length > 0);

    // Remove the first segment (the base route like 'resource', 'resourcePilot', 'res', etc.)
    // and reconstruct the API path
    const apiPath = pathSegments.slice(1).join('/');

    // Combine RAT URL with the API path, preserving query string and hash
    const ratUrl = appConfig.ratUrl.endsWith('/') ? appConfig.ratUrl.slice(0, -1) : appConfig.ratUrl;
    return `${ratUrl}/${apiPath}${url.search}${url.hash}`;
  } catch (error) {
    // Fallback in case URL parsing fails
    console.error('Failed to parse nextPageLink:', nextPageLink, error);
    return nextPageLink;
  }
};

export { fetchOdataAll, getRatConvertedNextPageLink };
